import { requestBuilder } from '../../http/RequestBuilder';
import type { GeneralResponse } from '../../http/types/Common';

interface UseDeleteQuilttConnectionBody {
    connectionId: string;
}

const useDeleteQuilttConnection = requestBuilder.mutation<
    GeneralResponse,
    UseDeleteQuilttConnectionBody
>({
    endpoint: '/api/holistic/delete-connection',
    method: 'PATCH',
});

export default useDeleteQuilttConnection;
